/* eslint-disable max-len */
import { useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import styled from "styled-components";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import NormalIcon from "../../components/Icon";
import { Icon } from "@mui/material";
import { StyledText, TextSize, TextStatus } from "../../components/Text";
import Card from "../../components/Card";
import {
  LocationInterface,
  RightAlign,
} from "../../components/UtilsComponents";
import ALink from "../../components/ALink";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ConfirmModal from "../../components/ConfirmModal";
import CustomDatePicker from "../../components/CustomDatePicker";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import moment from "moment";
import { SemesterContext } from "../../context/SemesterContext";
import defaultImg from "../../assets/DefaultCardImage.png";
import SnackBar from "../../components/SnackBar";
import { EmptyMilestoneType, MilestoneType } from "../../types/Milestone";
import EditModal from "./EditModal";
import dayjs from "dayjs";
import { handleJWTError } from "../../hooks/jwtErrHandler";

type BlockProps = {
  backgroundColor: string;
};
const StyledButton = styled(Button)`
  background: rgba(255, 255, 255, 0.33);
  /* Other/Border */

  border: 1px solid #e7ebee;
  box-sizing: border-box;
  backdrop-filter: blur(33px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 6px;
  &:hover:not(:disabled){
    background-color: rgba(255, 255, 255, 0.33);
    -webkit-text-decoration: none;
    text-decoration: none;
    color: #E5E5E5;
  },
`;
const SkillCompleted = styled(Card)`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;

  position: static;
  width: auto;
  height: auto;
  left: 0px;
  top: 0px;

  /* Dark outline transparent */

  background: rgba(0, 0, 0, 0.3);
  border: 2px solid #36eab9;
  box-shadow: 0px 4px 35px #54c2ab;
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 10px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 20px;
  cursor: pointer;
`;
const SkillOptional = styled(Card)`
  // overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;

  position: static;
  width: auto;
  height: auto;
  left: 0px;
  top: 0px;

  background: #191b34;
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 10px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 20px;
  cursor: pointer;
`;
const CustomBlock = styled(FlexGrow) <BlockProps>`
  margin-bottom: 16px;
  // text-align: center;
  background: ${({ backgroundColor }) => backgroundColor};
  padding: 0px 16px 16px 16px;
  flex-grow: 0;
  position: relative;
  cursor: pointer;
  width: 171px;
  min-width: 171px;
  max-width: 171px;
  // height: 270px;
  // overflow: auto;
  // min-height: 270px;
  // max-height: 270px;
  // overflow: hidden;
  border-radius: 12px;
  //   :after {
  //     border-bottom: 20px solid transparent;
  //     border-left: 20px solid transparent;
  //     border-right: 20px solid;
  //     // border-image-source: ${({ backgroundColor }) => backgroundColor};
  //     // border-color: ${({ backgroundColor }) => backgroundColor};
  //     content: '';
  //     height: 0;
  //     position: absolute;
  //     top: 11px;
  //     width: 0;
  //     right: 2px;
  //     transform: rotate(45deg);
  // }
  // }
  // :before {
  //   border-bottom: 20px solid transparent;
  //   border-left: 20px solid;
  //   // border-image-source: ${({ backgroundColor }) => backgroundColor};
  //   // border-color: ${({ backgroundColor }) => backgroundColor};
  //   border-right: 20px solid transparent;
  //   content: '';
  //   height: 0;
  //   position: absolute;
  //   top: 11px;
  //   width: 0;
  //   left: 2px;
  //   transform: rotate(312deg);
  // }
`;
const StyledHr = styled.hr`
  width: 96%;
  border-color: #3c406c;
  margin-top: 16px;
  margin-bottom: 16px;
`;
const StyledImg = styled.img`
  width: 100%;
  height: 200px;
  max-height: 65%;
  min-height: 65%;
  margin-bottom: 10px;
  border-radius: 7px;
`;
interface Props {
  isSnackbarOpen: boolean;
  setIsSnackbarOpen: any;
  message: string;
  setMessage: any;
}
function RoadMapDetailPage(props: Props) {
  const { isSnackbarOpen, setIsSnackbarOpen, message, setMessage } = props;
  const navigate = useNavigate();
  const screenClass = useScreenClass();
  let location = useLocation() as LocationInterface;
  const stateData = location.state;
  const [searchParams] = useSearchParams();
  const roadmapId = searchParams.get("rid");
  const milestoneId = searchParams.get("mid");
  const userContext = useContext(UserContext);
  const currentUser = userContext.user;
  const roadmapViewData = userContext.roadmapView;
  const [milestone, setMilestone] = useState<MilestoneType>(EmptyMilestoneType);
  const semesterContext = useContext(SemesterContext);
  const [confirm, setConfirm] = useState<boolean>(false);
  // const [archiveConfirm, setArchiveConfirm] = useState<boolean>(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false);
  // const [message, setMessage] = useState<string>("");
  // const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [competencyDetail, setCompetencyDetail] = useState<any>({
    semester_detail: { instructors: "" },
  });
  const [startDate, setStartDate] = useState(
    milestone.start_date
      ? dayjs(milestone?.start_date.includes("UTC"))
        ? dayjs(milestone?.start_date.split(" 00")[0])
        : dayjs(milestone?.start_date)
      : dayjs(semesterContext.selectedSemester.start_date)
  );
  const [endDate, setEndDate] = useState(
    milestone.target_completion_date
      ? milestone?.target_completion_date.includes("UTC")
        ? milestone?.target_completion_date.split(" 00")[0]
        : milestone?.target_completion_date
      : semesterContext.selectedSemester.end_date
  );

  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );

  // useEffect(() => {
  //   if (milestoneId && stateData) {
  //     fetchDetail(stateData.selectedStudentData.id, milestoneId);
  //   } else if (milestoneId) {
  //     fetchDetail(currentUser.id, milestoneId);
  //   } else {
  //     fetchDetail("", "");
  //   }
  // }, [milestoneId, stateData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (milestoneId && stateData) {
          await fetchDetail(stateData.selectedStudentData.id, milestoneId);
        } else if (milestoneId) {
          await fetchDetail(currentUser.id, milestoneId);
        } else {
          await fetchDetail("", "");
        }
      } catch (error) {
        console.error("Error fetching detail:", error);
      } finally {
      }
    };

    // Only trigger fetch if milestoneId is present
    if (milestoneId) {
      fetchData();
    }
  }, [milestoneId, stateData]);

  const fetchDetail = async (stId: string, id: string) => {
    axios
      .get(`/roadmap/milestones/detail?student_id=${stId}&milestone_id=${id}`)
      .then((res: any) => {
        setMilestone(res.data.milestone);
        {
          setEndDate(
            res.data?.milestone?.target_completion_date.includes("UTC")
              ? res.data?.milestone?.target_completion_date.split(" 00")[0]
              : res.data?.milestone?.target_completion_date
          );

          setStartDate(
            res.data?.milestone?.start_date.includes("UTC")
              ? res.data?.milestone?.start_date.split(" 00")[0]
              : res.data?.milestone?.start_date
          );
        }

        axios(
          `/student/version?student_id=${stId}&semester_name=${semesterContext.selectedSemester.label}&program_id=${userContext.user?.programs?.[0]?.id}`
        )
          .then((res1: any) => {
            var url = `/competency/detail?competency_code=${res?.data?.milestone.competency_card.competency_code}&university_code=CMKL&curriculum_version=${res1.data.version.curriculum_version}&semester_name=${semesterContext.selectedSemester.label}`;
            if (semesterContext.selectedSemester.label === "All") {
              url = `/competency/detail?competency_code=${res?.data?.milestone.competency_card.competency_code}&university_code=CMKL&curriculum_version=${res1.data.version.curriculum_version}`;
            }
            axios
              .get(url)
              .then((res2) => {
                setCompetencyDetail(res2.data.competency);
              })
              .catch(() => { });
          })
          .catch(() => { });
      })
      .catch((err) => {
        setMilestone(EmptyMilestoneType);
        handleJWTError(err);
      });
  };
  const updateMilestone = (startDateDisabled: boolean) => {
    // console.log(
    //   dayjs(startDate).format("YYYY-MM-DD"),
    //   dayjs(endDate).format("YYYY-MM-DD")
    // );
    if (!startDate || !endDate) {
      setErrorMessage("Select valid start and end dates!");
      // setErrorMessage(res.data.roadmaps[0].message);
      setIsErrorOpen(true);
    } else if (
      dayjs(startDate).format("YYYY-MM-DD") ===
      dayjs(endDate).format("YYYY-MM-DD")
    ) {
      setErrorMessage("Start Date and End date cannot be the same!");
      // setErrorMessage(res.data.roadmaps[0].message);
      setIsErrorOpen(true);
    } else {
      axios
        .put(
          "/roadmap/milestones/update",
          startDateDisabled
            ? {
              student_id: currentUser.id,
              milestone_id: milestone.id,
              title: milestone.title,
              description: milestone.description,
              // start_date: moment(startDate).format('YYYY-MM-DD'),
              target_date: moment(endDate).format("YYYY-MM-DD"),
              year: Number(semesterContext.selectedSemester.year),
              semester: semesterContext.selectedSemester.label,
            }
            : {
              student_id: currentUser.id,
              milestone_id: milestone.id,
              title: milestone.title,
              description: milestone.description,
              start_date: dayjs(startDate).format("YYYY-MM-DD"),
              target_date: dayjs(endDate).format("YYYY-MM-DD"),
              year: Number(semesterContext.selectedSemester.year),
              semester: semesterContext.selectedSemester.label,
            }
        )
        .then((res) => {
          setMilestone(res.data.roadmaps);
          setIsCalendarOpen(false);
          setMessage("Your competency has been updated");
          setIsSnackbarOpen(true);
          if (milestoneId && stateData) {
            fetchDetail(stateData.selectedStudentData.id, milestoneId);
          } else if (milestoneId) {
            fetchDetail(currentUser.id, milestoneId);
          } else {
            fetchDetail("", "");
          }
        })
        .catch(function (error) {
          if (error.response) {
            setErrorMessage(
              error.response.data.error || "Failed to update competency!"
            );
            setIsErrorOpen(true);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("Error", error.message);
          }
        });
    }
  };
  const deleteMilestone = (action: string) => {
    axios
      .delete(
        `/roadmap/milestones/delete?student_id=${currentUser.id}&milestone_id=${milestone.id}&roadmap_id=${roadmapId}`
      )
      .then((res) => {
        setConfirm(false);
        setMessage(`Your competency has been ${action}`);
        setIsSnackbarOpen(true);
        redirectChild();
        // setTimeout(() => {
        //   redirectChild();
        // }, 4000);
      })
      .catch(function (error) {
        if (error.response) {
          setErrorMessage(
            error.response.data.error || "Failed to update competency!"
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
        handleJWTError(error);
      });
  };

  const redirectChild = () => {
    if (stateData) {
      const stData = stateData.selectedStudentData;
      navigate(roadmapViewData.url, {
        state: { selectedStudentData: stData },
      });
    } else {
      navigate(roadmapViewData.url);
    }
  };
  return (
    <>
      {/* <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
        link
      /> */}
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={errorMessage}
        type="error"
      />

      <ConfirmModal
        title="Delete competency"
        description="Do you really want to delete this competency?"
        setOpen={setConfirm}
        isOpen={confirm}
        confirmFunction={() => {
          deleteMilestone("deleted");
        }}
      />

      <EditModal
        title={`[${milestone.competency_card.competency_code}] ${milestone.competency_card.title}`}
        semesterStartDate={semesterContext.selectedSemester.start_date}
        semesterEndDate={semesterContext.selectedSemester.end_date}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        status={milestone.status}
        isOpen={isCalendarOpen}
        setOpen={setIsCalendarOpen}
        onConfirm={updateMilestone}
      />

      <FlexBox style={{ padding: "16px" }}>
        <FlexGrow>
          <StyledButton onClick={() => redirectChild()}>
            <NormalIcon
              name="angle-left"
              size={2.5}
              style={{ height: "20px", marginRight: "5px" }}
            />
            Back
          </StyledButton>
        </FlexGrow>
      </FlexBox>
      <FlexBox>
        <FlexGrow>
          <FlexBox
            alignItems="flex-start"
            style={{ background: "rgb(17 20 42)", padding: "16px" }}
          >
            <CustomBlock backgroundColor={milestone.graphics.iconbg}>
              <div
                style={{
                  padding: "5px 0px",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {milestone.competency_card.competency_code}
              </div>
              <StyledImg
                src={
                  milestone.competency_card.graphics.imgurl
                    ? process.env.REACT_APP_IMG_URL +
                    milestone.competency_card.graphics.imgurl
                    : defaultImg
                }
                alt=""
              />
              <Icon
                sx={{
                  color: "white",
                  padding: "6px",
                  background: milestone.competency_card.graphics.iconbg,
                  borderRadius: "100px",
                  fontSize: "27px",
                  position: "absolute",
                  top: "212px",
                  right: "80px",
                  boxShadow: milestone.competency_card.graphics.iconshadow,
                }}
              >
                {milestone.competency_card.graphics.icon}
              </Icon>
              <div style={{ textAlign: "center" }}>{milestone.title}</div>
            </CustomBlock>
            <FlexGrow>
              <FlexBox direction="column" alignItems="flex-start">
                <>
                  {/* <FlexGrow>
                  <StyledText
                    color="#E6E6E6"
                    fontWeight="400"
                    style={{ fontSize: '12px' }}>
                    Engineering
                  </StyledText>
                </FlexGrow> */}
                  <FlexGrow style={{ margin: 0 }}>
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="700"
                      style={{ fontSize: "32px", marginRight: "5px" }}
                    >
                      [{milestone.competency_card.competency_code}]
                    </StyledText>
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="700"
                      style={{ fontSize: "32px" }}
                    >
                      {milestone.title}
                    </StyledText>
                  </FlexGrow>
                  <FlexGrow>
                    <StyledText
                      color="#9295AA"
                      fontWeight="400"
                      style={{ fontSize: "16px" }}
                    >
                      {milestone.description}
                    </StyledText>
                  </FlexGrow>
                  <FlexGrow>
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="400"
                      style={{ fontSize: "16px", paddingRight: "5px" }}
                    >
                      Credits: {milestone.competency_card.credits}
                    </StyledText>
                    {milestone.required && (
                      <StyledText style={{ color: "#ffffff" }}>
                        -- REQUIRED
                      </StyledText>
                    )}
                  </FlexGrow>
                  <FlexGrow>
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="400"
                      style={{ fontSize: "16px", paddingRight: "5px" }}
                    >
                      Version: {competencyDetail.display_version}
                    </StyledText>
                  </FlexGrow>
                  <FlexGrow>
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="400"
                      style={{ fontSize: "16px", paddingRight: "5px" }}
                    >
                      Instructor:{" "}
                      {milestone.semester_detail?.instructors ||
                        competencyDetail.instructors}
                    </StyledText>
                  </FlexGrow>
                  <FlexGrow>
                    <NormalIcon name="map-pin" />
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="400"
                      style={{ fontSize: "16px" }}
                    >
                      Start date: {milestone.semester_detail?.start_date}
                    </StyledText>
                  </FlexGrow>
                  <FlexGrow>
                    <NormalIcon name="hunting" />
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="400"
                      style={{ fontSize: "16px" }}
                    >
                      Target completion date: {milestone.semester_detail?.end_date}
                    </StyledText>
                    {/* {currentUser.role === 1 && (
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setIsCalendarOpen(true);
                        }}
                      >
                        <NormalIcon ml={2} name="edit" color="#ffd900c9" />
                      </span>
                    )} */}
                    <Icon
                      sx={{
                        verticalAlign: "text-bottom",
                        fontSize: "21px",
                        color:
                          milestone.status === "Active"
                            ? "#3CC13B"
                            : milestone.status === "Planned"
                              ? "#ffd900c9"
                              : "#ffd900c9",
                        marginLeft: "32px",
                      }}
                    >
                      fiber_manual_record
                    </Icon>
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="400"
                      style={{ fontSize: "16px" }}
                    >
                      {milestone.status}
                    </StyledText>
                  </FlexGrow>

                  <FlexGrow>
                    <NormalIcon name="clock" />
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="400"
                      style={{ fontSize: "16px" }}
                    >
                      Schedule: {milestone.semester_detail?.weekday} , {milestone.semester_detail?.start_time} - {milestone.semester_detail?.end_time} , {milestone.semester_detail?.location}
                    </StyledText>
                  </FlexGrow>
                  {currentUser.role === 1 && (
                    <>
                      {
                        // milestone.competency_card.status === "Completed" ? (
                        //   <FlexGrow
                        //     onClick={() => {
                        //       setArchiveConfirm(true);
                        //     }}
                        //     style={{
                        //       cursor: "pointer",
                        //       border: "1px solid gray",
                        //       borderRadius: "7px",
                        //       padding: "6px",
                        //     }}
                        //   >
                        //     <StyledText
                        //       color="white"
                        //       fontWeight="500"
                        //       style={{
                        //         fontSize: "16px",
                        //         textAlign: "center",
                        //         textTransform: "capitalize",
                        //       }}
                        //     >
                        //       Archive Competency Card
                        //     </StyledText>
                        //     <NormalIcon ml={2} name="trash" color="white" />
                        //   </FlexGrow>
                        // ) :
                        <FlexGrow
                          onClick={() => {
                            setConfirm(true);
                          }}
                          style={{
                            cursor: "pointer",
                            border: "1px solid red",
                            borderRadius: "7px",
                            padding: "6px",
                          }}
                        >
                          <StyledText
                            color="red"
                            fontWeight="500"
                            style={{
                              fontSize: "16px",
                              textAlign: "center",
                              textTransform: "capitalize",
                            }}
                          >
                            Delete Competency Card
                          </StyledText>
                          <NormalIcon ml={2} name="trash" color="red" />
                        </FlexGrow>
                      }
                    </>
                  )}
                  {/* <div>
                    <NormalIcon
                      color="#1990FF"
                      mr={1}
                      name="external-link-alt"
                    />
                    <ALink color="#1990FF">Link to resources</ALink>
                  </div> */}
                </>
              </FlexBox>
            </FlexGrow>
          </FlexBox>
          <FlexBox>
            <FlexGrow>
              <StyledHr />
            </FlexGrow>
          </FlexBox>
          {competencyDetail?.semester_detail?.is_attendance_required && <div
            style={{
              display: "flex",
              alignItems: "center",
              background: "linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%)",
              border: "1px solid rgba(255, 193, 7, 0.3)",
              borderLeft: "4px solid #ffc107",
              borderRadius: 8,
              padding: "12px 16px",
              // marginTop: 16,
              marginBottom: 8,
              boxShadow: "0 2px 8px rgba(255, 193, 7, 0.1)",
            }}
          >
            <Icon
              title="Attendance Required"
              sx={{
                color: "#ffc107",
                fontSize: "24px",
                marginRight: "12px",
                flexShrink: 0,
              }}
            >
              how_to_reg
            </Icon>
            <span
              style={{
                color: "#f57c00",
                fontSize: "14px",
                lineHeight: "1.5",
                fontWeight: 500,
              }}
            >
              Students must attend lectures as defined by the instructor to earn this competency
            </span>
          </div>}
          <FlexBox>
            <FlexGrow style={{ padding: "20px" }}>
              <h3>Skills</h3>
            </FlexGrow>
          </FlexBox>
          <FlexBox alignItems="start">
            {milestone.competency_card?.skills?.map((item: any, index: any) => (
              <FlexGrow
                style={{
                  maxWidth: isMobile ? "unset" : "48%",
                  minWidth: isMobile ? "100%" : "48%",
                  marginBottom: "16px",
                  alignItems: "start",
                }}
              >
                {item.completed ? (
                  <SkillCompleted>
                    <FlexGrow style={{ width: "100%", flexGrow: 0 }}>
                      <FlexBox style={{ width: "100%" }}>
                        <FlexGrow>
                          {item.required ? (
                            <StyledText
                              status={TextStatus.muted}
                              textSize={TextSize.default}
                              fontWeight="normal"
                            >
                              Required
                            </StyledText>
                          ) : (
                            <StyledText
                              status={TextStatus.muted}
                              textSize={TextSize.default}
                              fontWeight="normal"
                            >
                              Optional
                            </StyledText>
                          )}
                        </FlexGrow>
                        <FlexGrow>
                          <RightAlign>
                            <StyledText
                              textSize={TextSize.paragraph}
                              fontWeight="600"
                            >
                              Completed
                              <NormalIcon name="check" />
                            </StyledText>
                          </RightAlign>
                        </FlexGrow>
                      </FlexBox>
                      <StyledHr />
                    </FlexGrow>
                    <FlexGrow style={{ width: "100%" }}>
                      <div>
                        <StyledText
                          textSize={TextSize.paragraph}
                          fontWeight="700"
                        >
                          [{item.skill_code}]
                        </StyledText>
                      </div>
                      <div>
                        <StyledText
                          textSize={TextSize.paragraph}
                          fontWeight="600"
                        >
                          {item.title}
                        </StyledText>
                      </div>
                      <div>
                        <StyledText
                          status={TextStatus.muted}
                          style={{ fontSize: "12px" }}
                          fontWeight="normal"
                        >
                          {item.description}
                        </StyledText>
                      </div>
                      <ul>
                        <li>
                          <div>
                            <StyledText
                              status={TextStatus.warning}
                              style={{ fontWeight: "bold" }}
                            >
                              {/* <span style={{ color: "orange" }}>
                                Assessment :
                              </span>{" "} */}
                              {item?.assessment?.title}
                            </StyledText>
                          </div>
                          <StyledText status={TextStatus.muted}>
                            {item?.assessment?.description}
                          </StyledText>
                        </li>
                        {item?.topic_title && (
                          <li>
                            <div>
                              <StyledText
                                status={TextStatus.warning}
                                style={{ fontWeight: "bold" }}
                              >
                                <span style={{ color: "orange" }}>Topic :</span>{" "}
                                {item?.topic_title}
                              </StyledText>
                            </div>
                            <StyledText status={TextStatus.muted}>
                              {item?.topic_description}
                            </StyledText>
                          </li>
                        )}
                      </ul>
                    </FlexGrow>
                    {
                      <>
                        <StyledHr />
                        <FlexBox style={{ width: "100%" }}>
                          <FlexGrow></FlexGrow>
                          <FlexGrow>
                            <RightAlign>
                              <StyledText
                                textSize={TextSize.paragraph}
                                fontWeight="600"
                              >
                                Result: {item.assessment.result}
                              </StyledText>
                            </RightAlign>
                          </FlexGrow>
                        </FlexBox>
                      </>
                    }
                  </SkillCompleted>
                ) : (
                  <SkillOptional>
                    <FlexGrow style={{ width: "100%", flexGrow: 0 }}>
                      <div>
                        {item.required ? (
                          <StyledText
                            status={TextStatus.muted}
                            textSize={TextSize.default}
                            fontWeight="normal"
                          >
                            Required
                          </StyledText>
                        ) : (
                          <StyledText
                            status={TextStatus.muted}
                            textSize={TextSize.default}
                            fontWeight="normal"
                          >
                            Optional
                          </StyledText>
                        )}
                      </div>
                      <StyledHr />
                    </FlexGrow>
                    <FlexGrow style={{ width: "100%" }}>
                      <div>
                        <StyledText
                          textSize={TextSize.paragraph}
                          fontWeight="700"
                        >
                          [{item.skill_code}]
                        </StyledText>
                      </div>
                      <div>
                        <StyledText
                          textSize={TextSize.paragraph}
                          fontWeight="600"
                        >
                          {item.title}
                        </StyledText>
                      </div>
                      <div>
                        <StyledText
                          status={TextStatus.muted}
                          style={{ fontSize: "12px" }}
                          fontWeight="normal"
                        >
                          {item.description}
                        </StyledText>
                      </div>
                      <ul>
                        <li>
                          <div>
                            <StyledText
                              status={TextStatus.warning}
                              style={{ fontWeight: "bold" }}
                            >
                              {/* <span style={{ color: "orange" }}>
                                Assessment :
                              </span>{" "} */}
                              {item?.assessment?.title}
                            </StyledText>
                          </div>
                          <StyledText status={TextStatus.muted}>
                            {item?.assessment?.description}
                          </StyledText>
                        </li>
                        {item?.topic_title && (
                          <li>
                            <div>
                              <StyledText
                                status={TextStatus.warning}
                                style={{ fontWeight: "bold" }}
                              >
                                <span style={{ color: "orange" }}>Topic :</span>{" "}
                                {item?.topic_title}
                              </StyledText>
                            </div>
                            <StyledText status={TextStatus.muted}>
                              {item?.topic_description}
                            </StyledText>
                          </li>
                        )}
                      </ul>
                    </FlexGrow>
                    {item.assessment &&
                      item.assessment.assessment_time &&
                      item.assessment.assessment_time !== "" && (
                        <>
                          <StyledHr />
                          <FlexBox style={{ width: "100%" }}>
                            <FlexGrow></FlexGrow>
                            <FlexGrow>
                              <RightAlign>
                                <StyledText
                                  textSize={TextSize.paragraph}
                                  fontWeight="600"
                                >
                                  Result: {item.assessment.result}
                                </StyledText>
                              </RightAlign>
                            </FlexGrow>
                          </FlexBox>
                        </>
                      )}
                  </SkillOptional>
                )}
              </FlexGrow>
            ))}
          </FlexBox>
        </FlexGrow>
      </FlexBox>
    </>
  );
}
export default RoadMapDetailPage;
